import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {share, tap} from 'rxjs/operators';
import {Store} from '@ngxs/store';
import {Loader} from '../../models/loader/loader.redux';

@Injectable()
export class IsLoggedInterceptor implements HttpInterceptor {
  private sessionCache: Map<string, HttpResponse<any>> = new Map();
  private cachedTime: number;
  constructor(
    private store: Store
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const regex = /^[\w\W]*\/(billing\/subscriptions\/)[a-zA-Z0-9]*(\/active)$/gm;
    if (request.url.endsWith('auth/isLogged') || request.url.match(regex)) {
      const cachedResponse: HttpResponse<any> = this.sessionCache.get(request.url);
      if (cachedResponse && (Date.now() - this.cachedTime) < 60000) {
        return of(cachedResponse.clone());
      } else {
        // TODO: agregue este loader para cuando se haga el is logged
        this.store.dispatch(new Loader(true));
        return next.handle(request).pipe(tap(stateEvent => {
          if (stateEvent instanceof HttpResponse) {
            this.cachedTime = Date.now();
            this.sessionCache.set(request.url, stateEvent.clone());
          }
        }), share());
      }
    } else {
      return next.handle(request);
    }
  }
}
